import Button from 'v3/common/components/Button';
import CopyTextButton from 'v3/common/components/CopyTextButton';
import { useStaticIP } from './useStaticIP';
import LoadingSpinner from 'v3/common/components/LoadingSpinner';
import { Badge } from 'react-bootstrap';
import classNames from 'classnames';

const StaticIpCard = () => {
  const {
    staticIpState: { userIPDetails, isLoading, buttonLoader },
    onHandleClaim,
    canClaimIp,
  } = useStaticIP();

  const { ip } = userIPDetails || {};
  const isIpActive = Boolean(ip);

  return (
    <LoadingSpinner isLoading={isLoading}>
      <div className="static-ip-plan-box">
        <div className="static-ip-plan-box__header">
          <h6>
            <i className="fa-regular fa-globe" />
            Static IP
          </h6>

          <Badge
            className={classNames('static-ip-plan-box__header__badge', {
              active: isIpActive,
            })}
          >
            {isIpActive ? 'Active' : 'Inactive'}
          </Badge>
        </div>

        {!isIpActive && !canClaimIp && (
          <div className="static-ip-plan-box__card">
            <div className="details">
              <i className="fa-regular fa-globe" />
              {window.SA_FEATURE_FLAGS.staticIpEnabledBrokers.includes(window.currentUserBroker) ? (
                <p>To claim your static IP, please purchase a plan first.</p>
              ) : (
                <p>To claim your static IP, please contact support team.</p>
              )}
            </div>
          </div>
        )}

        {isIpActive && (
          <div className="static-ip-plan-box__card">
            <div>
              <p>Your IP Address</p>
              <span>{ip}</span>
            </div>
            <CopyTextButton successText="IP Copied Sucessfully." text={ip ?? ''} />
          </div>
        )}

        {!isIpActive &&
          canClaimIp &&
          window.SA_FEATURE_FLAGS.staticIpEnabledBrokers.includes(window.currentUserBroker) && (
            <Button type="button" isLoading={buttonLoader} disabled={buttonLoader} onClick={onHandleClaim}>
              Claim Your Static IP
            </Button>
          )}
      </div>
    </LoadingSpinner>
  );
};

export default StaticIpCard;
